import React from 'react';
import ReactDOM from 'react-dom/client';
import { QueryClientProvider } from '@tanstack/react-query';
import App from './App';
import { NotificationProvider } from 'shared/components/NotificationContext';
import { HashRouter } from 'react-router-dom';
import { queryClient } from 'core/queryClient';

const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <HashRouter>
        <NotificationProvider>
          <App />
        </NotificationProvider>
      </HashRouter>
    </QueryClientProvider>
  </React.StrictMode>
);